import { BydCleanInstance, BYD_CLEAN_INSTANCE_KEY } from '@sixense/byd-clean-instance';
import { DS_FIELDS_TABLE_REF_SEPARATOR } from '../constants/ds-forms-fields-table-ref-separator.constant';

@BydCleanInstance
@Reflect.metadata(BYD_CLEAN_INSTANCE_KEY, [null, undefined, []])
export class DsFormInstanceTableValue {
  /**
   * Ref line~col
   */
  ref: string;

  /**
   * Value of cell
   */
  value: number | string;

  /**
   * DsFormInstanceTableValue constructor.
   *
   * @param ref column and row
   * @param value tring | number value
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(ref: any, value: string | number) {
    this.ref = ref.rowIndex + DS_FIELDS_TABLE_REF_SEPARATOR + ref.columnIndex;
    this.value = value;
  }
}
